export const BASE_URL = '/api/v1/b2b-enrollment'
